import { AudioBookItem, GameItem, MediaType, MusicItem, VideoItem } from './client-types';

export enum CategoryType {
  VIDEO = 'VIDEO',
  MUSIC = 'MUSIC',
  GAMES = 'GAMES',
  AUDIO_BOOKS = 'AUDIO_BOOKS',
}

export interface VideoCategory {
  id: string;
  category: string;
  slug: string;
  parentCategory?: string;
  color?: string;
  favourite?: boolean;
  childCategories?: number;
  childItems?: number;
  lastMediaAdded?: number;
  _new?: boolean;
  media?: VideoItem;
  primary?: PrimaryCategory;
  hide: boolean;
  sort: number;
  thumbnail?: string;
  excludeContinuesPlay?: boolean;
}

export interface MusicCategory {
  id: string;
  slug: string;
  category: string;
  parentCategory?: string;
  // color?: string; // are we using this?
  childCategories?: number;
  childItems?: number;
  lastMediaAdded?: number;
  _new?: boolean;
  media?: MusicItem;
  primary?: PrimaryCategory;
  hide: boolean;
  sort: number;
  thumbnail?: string;
  excludeContinuesPlay?: boolean;
}

export interface GameCategory {
  id: string;
  slug: string;
  category: string;
  parentCategory?: string;
  childCategories?: number;
  childItems?: number;
  lastMediaAdded?: number;
  _new?: boolean;
  media?: GameItem;
  primary?: PrimaryCategory;
  hide: boolean;
  sort: number;
  thumbnail?: string;
}

export interface AudioBookCategory {
  id: string;
  slug: string;
  category: string;
  parentCategory?: string;
  childCategories?: number;
  childItems?: number;
  lastMediaAdded?: number;
  _new?: boolean;
  media?: AudioBookItem;
  primary?: PrimaryCategory;
  hide: boolean;
  sort: number;
  thumbnail?: string;
}

export type locales = 'International' | 'Australia' | 'New Zealand';

export interface Artist {
  id: string;
  name: string;
  slug: string;
}

export interface PrimaryCategory {
  color: string;
  icon: string;
  order?: number;
  text: string;
}

export interface MusicStream {
  ref?: string;
  expires?: number;
  issuedAt?: number;
  message?: string;
  subscriptionId?: string;
  status: 'ERROR' | 'SUCCESS';
}

export interface Category {
  id: string;
  sk: string;
  type: MediaType;
  slug: string;
  category: string;
  parentCategory?: string;
  childCategories?: number;
  childItems?: number;
  media?: VideoItem | MusicItem;
  contentfulId?: string;
  primary?: PrimaryCategory;
  hide: boolean;
  sort: number;
  thumbnail: string;
  favourite?: boolean;
  pinToTop?: boolean;
  excludeFromSearch?: boolean;
  excludeContinuesPlay?: boolean;
}
